import { render, staticRenderFns } from "./AppointmentDialog.vue?vue&type=template&id=3bf5924c&scoped=true"
import script from "./AppointmentDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentDialog.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDialog.vue?vue&type=style&index=0&id=3bf5924c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5924c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf5924c')) {
      api.createRecord('3bf5924c', component.options)
    } else {
      api.reload('3bf5924c', component.options)
    }
    module.hot.accept("./AppointmentDialog.vue?vue&type=template&id=3bf5924c&scoped=true", function () {
      api.rerender('3bf5924c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AppointmentDialog.vue"
export default component.exports